import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { ApiService } from '../../root-services/api.service';
import { SAMLProviderListItem } from './saml-provider-list-item';
import { SAMLProvider } from './saml-provider';

@Injectable()
export class AuthSettingsService {

  constructor(private api: ApiService) { }

  public getProviders(edition_id: number): Observable<SAMLProviderListItem[]> {
      return this.api.get(`/editions/${edition_id}/saml_providers`)
        .map(response => response.json() as SAMLProviderListItem[])
        .publishReplay(1).refCount()
        .catch(this.handleError);
  }

  public getProviderSettings(edition_id: number, provider_id: number): Observable<SAMLProvider> {
      return this.api.get(`/editions/${edition_id}/saml_providers/${provider_id}`)
        .map(response => response.json() as SAMLProvider)
        .publishReplay(1).refCount()
        .catch(this.handleError);
  }

  public putProviderSettings(provider: SAMLProvider): Observable<any> {
    let edition_id = provider.edition_id;
    let provider_id = provider.id;
    return this.api.put(`/editions/${edition_id}/saml_providers/${provider_id}`, provider)
                   .map(() => {})
                   .publishReplay(1).refCount()
                   .catch(this.handleError);
  }

  public createProvider(provider: SAMLProvider): Observable<SAMLProvider> {
    let edition_id = provider.edition_id;
    return this.api.post(`/editions/${edition_id}/saml_providers`, provider)
                   .map(response => response.json() as SAMLProvider)
                   .publishReplay(1).refCount()
                   .catch(this.handleError);
  }

  // public editEdition(body: EditionSettings): Observable<any> {
  //   let editionId = this.editionList.getEdition().id.toString();
  //   return this.api.put('/editions/' + editionId, body)
  //                  .map(() => {})
  //                  .publishReplay(1).refCount()
  //                  .catch(this.handleError);
  // }

  // public jumpToLearning(path?: string): void {
  //   // fetches the learning URL for the current edition and redirects
  //   let url = '/get_learning_url';
  //   if(path) {
  //     url += '?path=' + encodeURI(path);
  //   }
  //   this.api.get(url)
  //       .map(response => response.json())
  //       .subscribe(response => {
  //     window.location.assign(response.url);
  //   });
  // }

  /**
   * Private Methods
   */
  private handleError(error: any): Promise<any> {
    console.error('An error occured:', error);
    let raisedError;
    if (error.json && error.json().error) {
      raisedError = error.json().error;
    }
    else if (error.message) {
      raisedError = error.message;
    }
    else {
      raisedError = error;
    }
    return Promise.reject(raisedError);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/global-settings/auth-settings/auth-settings.service.ts